import type { AjaxError } from 'rxjs';
import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable, concat } from '@helpcenter/epics-rxjs';

import type { HandleAjaxError } from '@helpcenter/flags';
import { handleAjaxError } from '@helpcenter/flags';
import { completeSignup } from 'rest/complete-signup';
import { resendValidationEmail } from 'rest/sign-up';
import type {
    CompleteSignup,
    CompleteSignupSuccess,
    CompleteSignupFailure,
    SendNewSignupLink,
    SendNewSignupLinkSuccess,
    SendNewSignupLinkFailure,
} from 'state/actions/complete-signup';
import {
    COMPLETE_SIGNUP,
    completeSignupSuccess,
    completeSignupFailure,
    SEND_NEW_SIGNUP_LINK,
    sendNewSignupLinkSuccess,
    sendNewSignupLinkFailure,
} from 'state/actions/complete-signup';
import type { LoginAttempt } from 'state/actions/login';
import { loginAttempt } from 'state/actions/login';
import { getDefaultSignUpError } from 'utils/errors';

export const completeSignupEpic: Epic<CompleteSignup, CompleteSignupSuccess | LoginAttempt | CompleteSignupFailure> = (
    action$
) => {
    return action$.ofType(COMPLETE_SIGNUP).mergeMap((completeSignupAction) => {
        const { jwtToken, fullName, password, email, contactAdminsFormEnabled, continueParam } =
            completeSignupAction.payload;
        return completeSignup(jwtToken, fullName, password)
            .flatMap(() => {
                return concat(
                    Observable.of(completeSignupSuccess()),
                    Observable.of(loginAttempt({ email, password, continueParam: continueParam ?? null }))
                );
            })
            .catch((error: AjaxError) => {
                const parsedError = getDefaultSignUpError(error, contactAdminsFormEnabled);
                return Observable.of(completeSignupFailure(parsedError));
            });
    });
};

export const sendNewSignupLinkEpic: Epic<
    SendNewSignupLink,
    SendNewSignupLinkSuccess | SendNewSignupLinkFailure | HandleAjaxError
> = (action$) => {
    return action$.ofType(SEND_NEW_SIGNUP_LINK).mergeMap((sendNewSignupLinkAction) => {
        const { email, portalId } = sendNewSignupLinkAction.payload;
        return resendValidationEmail(email, portalId, undefined)
            .map(() => {
                return sendNewSignupLinkSuccess();
            })
            .catch((error: AjaxError) => {
                return concat(Observable.of(sendNewSignupLinkFailure()), Observable.of(handleAjaxError(error)));
            });
    });
};
